import axios from "axios";

export default {
  async fetchProfile() {
    let cuid, activeSubscriberObject = {id: null};
    let activeSubscriber = localStorage.getItem("subscriber");
  
    if(activeSubscriber != null){
      activeSubscriberObject = JSON.parse(activeSubscriber);
      cuid =  activeSubscriberObject ? activeSubscriberObject.id : null;
    }

    return await axios
      .get("/auth/get-user", {params: {'cuid': cuid}})
      .then((response) => {
        // response.data.first_name = response.data.name;
        // response.data.last_name = '';
        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },
  updateProfile(payload: any) {
    return axios
      .post("/auth/change-password", payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },
  changePassword(payload: any) {
    return new Promise((resolve, reject) => {
      axios
        .post("auth/init_change_password", payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.log("error " + error);
          reject(error);
        });
    });
  },

  resetUserPasswordByAdmin(payload: any) {
    return axios
      .post("/users/reset-password", payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },
  async notifications(query: any = null) {
    return await axios
      .get("/auth/notifications", {
        params: query,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },
  async showNotifications(id: any) {
    return await axios
      .get("/auth/notifications/" + id)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },
  destroyNotifications(id: any) {
    return axios
      .delete("/auth/notifications/" + id)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },
  destroySelectedRows(payload: any) {
    return axios
      .put("/auth/notifications/destroySelectedRows", payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error.response;
      });
  },
};
